import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { DayjsDateTimePipe } from 'src/app/shared/pipes/dayjs-date-time.pipe'
import { DayjsDatePipe, DayjsPureDatePipe } from 'src/app/shared/pipes/dayjs-date.pipe'
import { RangePipe } from './range.pipe'
import { HighlightPipe } from './highlight.pipe'
import { DayjsFullTimePipe } from 'src/app/shared/pipes/dayjs-full-time.pipe'
import { EnumValuesPipe, KeysPipe } from './key-value.pipe'
import { DayjsDurationInHoursPipe, DayjsDurationPipe } from 'src/app/shared/pipes/dayjs-duration.pipe'
import { DayjsDaysBetweenDatesPipe } from 'src/app/shared/pipes/dayjs-days-between-dates.pipe'
import { LinebreaksPipe } from './linebreaks.pipe'
import { MacAddressPipe } from './mac-address.pipe'
import { DayjsDateFullTimePipe } from 'src/app/shared/pipes/dayjs-date-full-time.pipe'
import { HistoryDayOfWeek } from '@shared/pipes/historyDayOfWeek.pipe'
import { ChatMessageListGroupPipe } from '@shared/pipes/chat-message-list-group.pipe'
import { PlatformCurrencyPipe } from './platform-currency.pipe'

const pipes = [
  EnumValuesPipe,
  HighlightPipe,
  KeysPipe,
  DayjsDatePipe,
  DayjsDateTimePipe,
  DayjsDurationPipe,
  DayjsDurationInHoursPipe,
  DayjsFullTimePipe,
  DayjsDateFullTimePipe,
  DayjsPureDatePipe,
  DayjsDaysBetweenDatesPipe,
  RangePipe,
  LinebreaksPipe,
  MacAddressPipe,
  HistoryDayOfWeek,
  ChatMessageListGroupPipe,
  PlatformCurrencyPipe,
]

@NgModule({
  declarations: pipes,
  exports: pipes,
  imports: [CommonModule],
})
export class PipesModule {}
